<template>
  <div class="w-full px-4">
    <div class="w-full ">
      <Tabs
        :value="route.path"
        class="w-full"
      >
        <TabList>
          <Tab
            v-for="tab in items"
            :key="tab.label"
            :value="tab.route"
          >
            <router-link
              v-if="tab.route"
              v-slot="{ href, navigate }"
              :to="tab.route"
              custom
            >
              <a
                v-ripple
                :href="href"
                class="flex items-center gap-2 text-inherit no-underline"
                @click="navigate"
              >
                <i :class="tab.icon" />
                <span>{{ tab.label }}</span>
              </a>
            </router-link>
          </Tab>
        </TabList>
      </Tabs>
      <div class="w-full max-w-full pt-4 ">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// Define the tab items with icons
const items = ref([
    {
        route: '/contacts',
        label: 'Contacts',
        icon: 'pi pi-user'
    },
    {
        route: '/companies',
        label: 'Companies',
        icon: 'pi pi-building'
    },
    {
        route: '/services',
        label: 'Services',
        icon: 'pi pi-cog'
    },
    {
        route: '/venues',
        label: 'Venues',
        icon: 'pi pi-map-marker'
    },
    {
        route: '/internal-staff',
        label: 'Internal Staff',
        icon: 'pi pi-users'
    },
    {
        route: '/freelance-staff',
        label: 'Freelance Staff',
        icon: 'pi pi-id-card'
    }
]);
</script>

<style scoped>
/* Tab styling */
:deep(.p-tabs .p-tabs-nav) {
    background-color: transparent !important;
    border-width: 0 !important;
    padding: 0;
    margin-bottom: 2rem;
}

:deep(.p-tablist-active-bar) {
    background-color: rgb(59, 130, 246) !important;
    height: 3px !important;
}

:deep(.p-tabs .p-tabs-nav li .p-tab-nav-link) {
    background-color: white !important;
    color: black !important;
    border: none !important;
    border-radius: 8px 8px 0 0 !important;
    margin-right: 4px !important;
    padding: 1rem 1.5rem;
    transition: background-color 0.2s ease;
}

:deep(.p-tabs .p-tabs-nav li.p-highlight .p-tab-nav-link) {
    background-color: rgb(255,249,179) !important;
    color: black !important;
    border: none !important;
}

:deep(.p-tabs .p-tabs-nav li:not(.p-highlight):not(.p-disabled):hover .p-tab-nav-link) {
    background-color: rgb(255,252,230) !important;
    color: black !important;
}
</style>
